export default function Input<T>(props: {
  value: T | undefined,
  type: "text" | "number",
  onChange: (value: T) => void,
  label: string,
  onBlur: () => void,
  validationState?: ValidationState
}) {
  const { value, type, onChange, label, onBlur, validationState } = props;

  const inputClassName = [
    "text-input__input",
    validationState === "valid" ? "valid" : "",
    validationState === "error" ? "error" : ""
  ].filter(Boolean).join(" ");

  return (
    <div className="text-input">
      <input
        role="input"
        tabIndex={0}
        onBlur={onBlur}
        aria-label={label}
        className={inputClassName}
        aria-placeholder={label}
        placeholder={label}
        type={type}
        aria-valuenow={(value as string) || ""}
        value={(value as string) || ""}
        onChange={(e) => onChange(e.target.value as T)}
      />
    </div>
  );
}